import React, { useState } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import SolutionsDialog from '../solutions/SolutionsDialog';

export default function Hero() {
  const [showSolutions, setShowSolutions] = useState(false);

  return (
    <div className="relative bg-white dark:bg-gray-900">
      <div className="relative pt-24 pb-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="sm:text-center md:mx-auto lg:col-span-6 lg:text-left">
              <h1>
                <span className="block text-base font-semibold text-purple-600">
                  Introducing Pino AI
                </span>
                <span className="mt-1 block text-4xl font-bold tracking-tight sm:text-5xl xl:text-6xl">
                  <span className="block text-gray-900 dark:text-white">Discover the Future of</span>
                  <span className="block text-purple-600">Website Development</span>
                </span>
              </h1>
              <p className="mt-3 text-base text-gray-500 dark:text-gray-400 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                Transform your online presence with our innovative AI-powered development services. As a cutting-edge startup, we're bringing the next generation of intelligent web solutions to businesses worldwide.
              </p>
              <div className="mt-8 sm:mx-auto sm:max-w-lg sm:text-center lg:mx-0 lg:text-left">
                <button
                  onClick={() => setShowSolutions(true)}
                  className="inline-flex items-center rounded-lg bg-purple-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2"
                >
                  Get Started
                  <ArrowRight className="ml-3 -mr-1 h-5 w-5" />
                </button>
              </div>
              <div className="mt-6 flex flex-col sm:flex-row sm:items-center sm:justify-center lg:justify-start gap-4">
                <div className="flex items-center">
                  <Sparkles className="h-5 w-5 text-yellow-400" />
                  <span className="ml-2 text-sm text-gray-500 dark:text-gray-400">
                    Next-Gen AI Solutions
                  </span>
                </div>
                <div className="flex items-center">
                  <div className="flex -space-x-2">
                    <img
                      className="inline-block h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt="Team member"
                    />
                    <img
                      className="inline-block h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt="Team member"
                    />
                    <img
                      className="inline-block h-8 w-8 rounded-full ring-2 ring-white"
                      src="https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                      alt="Team member"
                    />
                  </div>
                  <span className="ml-3 text-sm text-gray-500 dark:text-gray-400">
                    Join our Satisfied Clients
                  </span>
                </div>
              </div>
            </div>
            <div className="relative mt-12 sm:mx-auto lg:col-span-6 lg:mx-0 lg:mt-0 lg:flex lg:items-center">
              <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md">
                <div className="relative block w-full overflow-hidden rounded-lg bg-purple-600">
                  <img
                    className="w-full opacity-90 hover:opacity-100 transition-opacity"
                    src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=800&q=80"
                    alt="AI-powered web development"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-purple-600/50 to-blue-600/50 mix-blend-multiply" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <SolutionsDialog isOpen={showSolutions} onClose={() => setShowSolutions(false)} />
    </div>
  );
}